export default __webpack_public_path__ + "static/future_driven_thumbnail-f0b33621361a6ef5abe173855d9fcc80.png";